import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";
import axios from "axios";
import formattedDate from "../../formatDate";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Tag } from "primereact/tag";
import mapEtatFiche from "../../mapEtatFiche";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, TextareaAutosize } from "@mui/material";
import formatToISODate from "../../formatDateISO";
import { useParams } from "react-router-dom";
import FicheLogTerminal from "../../ficheDemande/journal";
import PdfButton from ".././pdfGenerator";
import { updateEnLigne } from "../projetService";
import mapTrajet from "../../mapTrajet";

const apiUrl = process.env.REACT_APP_API_URL;


const canSelect = true;


export default function EnCours() {

  const [copied, setCopied] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [dateMAJ, setDateMAJ] = useState("");
  const [infoMAJ, setInfoMAJ] = useState("");

  const [rechercheEncours, setRechercheEncours] = useState("");

  const [projets, setProjets] = useState([]);

  const [encours, setEncours] = useState([]);

  const [encour, setEncour] = useState([]);


  const [filtreEncours, setFiltreEnCours] = useState([projets]);

  const [visible, setVisible] = useState(false);

  const [etat, setEtat] = useState([]);
  const [note, setNote] = useState([]);
  const [infoSup, setInfoSup] = useState([]);

  const [tempIdProjet, setTempIdProjet] = useState([]);
  const [tempNom, setTempNom] = useState([]);
  const [tempTel, setTemptel] = useState([]);
  const [tempEmail, setTempEmail] = useState([]);
  const [tempAdresse, setTempAdresse] = useState([]);
  const [tempBesoin, setTempBesoin] = useState([]);

  const [rowClick, setRowClick] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);


  const [confirmVisible, setConfirmVisible] = useState(false);
  const [rowsToDelete, setRowsToDelete] = useState([]);


  useEffect(() => {
    fetch(`${apiUrl}IHM/api/navettes.php?encours=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setEncours(data.projets);
        }
      })
      .catch((err) => console.error(err));
  }, []);


  useEffect(() => {
    const rechercheMin = rechercheEncours.toLowerCase();
    const filteredList = encours.filter((projet) => {
      const nom = projet.nom_prenom?.toLowerCase() || "";
      const telephone = projet.numero_tel?.toLowerCase() || "";
  
      return (
        nom.includes(rechercheMin) ||
        telephone.includes(rechercheMin)
      );
    });
    setFiltreEnCours(filteredList);
  }, [rechercheEncours, encours]);

  const enteteTabeau1 = () => {
    return (
      <div className="flex justify-content-end">
        
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheEncours}
            onChange={(e) => setRechercheEncours(e.target.value)}
            placeholder="Rechercher"
          />
        </IconField>
      </div>
    );
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };


  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />


      <DataTable
        value={filtreEncours}
        size="small"
        paginator
        rows={25}
        header={enteteTabeau1}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        emptyMessage="Aucune fiche pour le moment"
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {filtreEncours.length}
          </span>
        }
      >
        
        <Column
          header="Date"
          field="date_creation"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (!rowData.date_creation || rowData.date_creation === "0000-00-00") {
              return <span>Non fixé </span>;
            }
            const date = new Date(rowData.date_creation);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span>
                {day}/{month}/{year}
              </span>
            );
          }}
        />
        <Column header="Client" field="nom_prenom" />

        <Column
          style={{ cursor: "pointer" }}
          header="Téléphone"
          field="numero_tel"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.numero_tel);
                }}
              >
                {rowData.numero_tel}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Type trajet"
          field="type_trajet"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.type_trajet);
                }}
              >
                {rowData.type_trajet}
              </span>
            </div>
          )}
        />
<Column 
        style={{cursor: "ponter"}}
        header="Trajet"
        field="trajet_detail"
        bodyStyle={{fontSize: "14px"}}
        body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.trajet_detail);
                }}
              >
                {mapTrajet(rowData.trajet_detail)}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Lieu"
          field="lieu_trajet"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.lieu_trajet);
                }}
              >
                {rowData.lieu_trajet}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Total"
          field="prix_total"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.prix_total);
                }}
              >
                {rowData.prix_total} €
              </span>
            </div>
          )}
        />

       
       
      </DataTable>
    </>
  );
}
